module.exports = __webpack_public_path__ + "static/media/myelin8.cffb86bf.jpg";